import store from './../game/store/index.js';
import config from './../config/config.js';
import VueSession from 'vue-session'
import axios from 'axios'


const auth = {
	install(Vue, options) {

		Vue.use(VueSession);

		const auth = axios.create({
			baseURL: config.api
		});

		const methods = {
			login(rec) {
				Vue.prototype.$session.start()
				Vue.prototype.$session.set('user', rec);
			},
			logout() {
				Vue.prototype.$session.destroy()
				window.location.reload(true);
			},
			hasAccess: function(component) {
				let user = this.getUser();
				if (user.role.includes('super manager')) return true;
				if (!config.auth[component]) return true;

				return config.auth[component].some(v => user.role.includes(v))
			},
			hasLocation: function(location_id) {
				let user = this.getUser();

				if (user.role.includes('super manager')) return true;

				if (!user.location) return false;

				return user.location.includes(location_id);
			},
			getUser() {
				return Vue.prototype.$session.get('user') || {}
			}
		}

		Vue.prototype.$auth = {...auth, ...methods };

	}
};

export default auth;
